import { cn } from "@/lib/utils"

interface OptionCardProps {
  active: boolean
  onClick: () => void
  className?: string
  children: React.ReactNode
}

export function OptionCard({
  active,
  onClick,
  className,
  children,
}: OptionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-lg border p-4 text-left transition-colors",
        active
          ? "border-blue-300 bg-gradient-to-b from-blue-50 to-white dark:from-blue-950/60 dark:to-blue-900/20"
          : "border-border hover:bg-muted/30",
        className,
      )}
    >
      {children}
    </button>
  )
}
